import { Outlet } from 'react-router-dom';

// No nav: the configurator is the only page, and it draws its own app bar. A shared header
// comes back when there is a second page to navigate to.
export function AppLayout() {
  return (
    <div className="app-shell">
      <Outlet />
    </div>
  );
}
